/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MonthlyCount } from './MonthlyCount';
import {
    MonthlyCountFromJSON,
    MonthlyCountFromJSONTyped,
    MonthlyCountToJSON,
    MonthlyCountToJSONTyped,
} from './MonthlyCount';
import type { MonthStat } from './MonthStat';
import {
    MonthStatFromJSON,
    MonthStatFromJSONTyped,
    MonthStatToJSON,
    MonthStatToJSONTyped,
} from './MonthStat';

/**
 * 
 * @export
 * @interface TrendData
 */
export interface TrendData {
    /**
     * 1-12月每月订单数与占比
     * @type {Array<MonthlyCount>}
     * @memberof TrendData
     */
    monthlyCounts?: Array<MonthlyCount>;
    /**
     * 年度总订单数
     * @type {number}
     * @memberof TrendData
     */
    yearTotal?: number;
    /**
     * 月均订单数
     * @type {number}
     * @memberof TrendData
     */
    monthlyAvg?: number;
    /**
     * 
     * @type {MonthStat}
     * @memberof TrendData
     */
    maxMonth?: MonthStat;
    /**
     * 
     * @type {MonthStat}
     * @memberof TrendData
     */
    minMonth?: MonthStat;
}

/**
 * Check if a given object implements the TrendData interface.
 */
export function instanceOfTrendData(value: object): value is TrendData {
    return true;
}

export function TrendDataFromJSON(json: any): TrendData {
    return TrendDataFromJSONTyped(json, false);
}

export function TrendDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrendData {
    if (json == null) {
        return json;
    }
    return {
        
        'monthlyCounts': json['monthlyCounts'] == null ? undefined : ((json['monthlyCounts'] as Array<any>).map(MonthlyCountFromJSON)),
        'yearTotal': json['yearTotal'] == null ? undefined : json['yearTotal'],
        'monthlyAvg': json['monthlyAvg'] == null ? undefined : json['monthlyAvg'],
        'maxMonth': json['maxMonth'] == null ? undefined : MonthStatFromJSON(json['maxMonth']),
        'minMonth': json['minMonth'] == null ? undefined : MonthStatFromJSON(json['minMonth']),
    };
}

export function TrendDataToJSON(json: any): TrendData {
    return TrendDataToJSONTyped(json, false);
}

export function TrendDataToJSONTyped(value?: TrendData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'monthlyCounts': value['monthlyCounts'] == null ? undefined : ((value['monthlyCounts'] as Array<any>).map(MonthlyCountToJSON)),
        'yearTotal': value['yearTotal'],
        'monthlyAvg': value['monthlyAvg'],
        'maxMonth': MonthStatToJSON(value['maxMonth']),
        'minMonth': MonthStatToJSON(value['minMonth']),
    };
}

